import moment from 'moment';

export default {
  methods: {
    /**
     * Reformat YYYY-MM-DD dates into DD/MM/YYYY, unless `long` then the format is dddd do MMMM YYYY
     *
     * @param dateString
     * @param long
     * @returns {string}
     */
    formatDate(dateString, long = false) {
      if (typeof dateString === 'undefined' || !dateString) {
        return '';
      }
      if (long === true) {
        return moment(dateString, 'YYYY-MM-DD').format('dddd Do MMMM YYYY');
      }
      return moment(dateString, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
  },
};
